import { Price } from '@shared/models/price.model';

export class AdditionalServiceSet {
  serviceProducts: AdditionalServiceVoice[];
  mutexServiceSets: AdditionalServiceMutex[];
}

export class AdditionalServiceVoice {
  instanceId: string;
  productId: string;
  description: string;
  longDescription: string;
  price: Price;
  requireICC: boolean;
  availableQuantity: number;
  icc: string;
  aNumber: string;
  orderSim: boolean;
  serviceStatus: ServiceStatus;
  canBeTerminated: boolean;
  mutexSetName: string;
  isCampaign: boolean;
  isDataSimCard: boolean;
  isTwinSimCard: boolean;
  isNettvern = false;
  startDate: string;
  endDate: string;
  isBarringService: boolean;
}

export class AdditionalServiceMutex {
  name: string;
  type: string;
  mutexServices: AdditionalServiceVoice[];
}

export enum ServiceStatus {
  Inactive = 'Inactive',
  Active = 'Active',
  Assigning = 'Assigning',
  Terminated = 'Terminated',
  Terminating = 'Terminating',
  Unknown = 'Terminated',
  ActiveUntilEndDate = 'ActiveUntilEndDate',
}

export class WhitelistEntries {
  whitelistEntry1?: string;
  whitelistEntry2?: string;
  whitelistEntry3?: string;
}
